module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目"
    }
  }, [_c('el-select', {
    staticStyle: {
      "max-width": "170px"
    },
    attrs: {
      "filterable": ""
    },
    on: {
      "change": _vm.getDevices
    },
    model: {
      value: (_vm.filters.projectId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "projectId", $$v)
      },
      expression: "filters.projectId"
    }
  }, _vm._l((_vm.projects), function(item) {
    return _c('el-option', {
      key: item.projectId,
      attrs: {
        "label": item.name,
        "value": item.projectId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "编码"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.filters.deviceId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "deviceId", $$v)
      },
      expression: "filters.deviceId"
    }
  }, [_c('el-option', {
    key: "0",
    attrs: {
      "label": " ",
      "value": "0"
    }
  }), _vm._v(" "), _vm._l((_vm.devices), function(item) {
    return _c('el-option', {
      key: item.deviceId,
      attrs: {
        "label": item.mnCode,
        "value": item.deviceId
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.filters.userId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "userId", $$v)
      },
      expression: "filters.userId"
    }
  }, [_c('el-option', {
    key: "0",
    attrs: {
      "label": " ",
      "value": "0"
    }
  }), _vm._v(" "), _vm._l((_vm.users), function(item) {
    return _c('el-option', {
      key: item.userId,
      attrs: {
        "label": item.name,
        "value": item.userId
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('my-button', {
    attrs: {
      "QueryButtonShow": "",
      "AddButtonShow": ""
    },
    on: {
      "select-type": _vm.clickBtn
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.ReviewSets,
      "highlight-current-row": "",
      "border": "",
      "height": _vm.formHeight,
      "size": "mini"
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mnCode",
      "label": "设备编码"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "审核人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "wayname",
      "label": "审核方式"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('drop-button', {
    attrs: {
      "disabled": this.sels.length === 0,
      "btnCon": "批量删除"
    },
    on: {
      "select-type": _vm.batchRemove
    }
  }), _vm._v(" "), _c('edit-button', {
    attrs: {
      "disabled": this.sels.length === 0,
      "btnCon": "批量修改"
    },
    on: {
      "select-type": _vm.handleEdit
    }
  }), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "page-sizes": [20, 50, 100, 200],
      "current-page": _vm.page
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        _vm.page = $event
      },
      "update:current-page": function($event) {
        _vm.page = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.type,
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formUser,
      "size": "normal",
      "id": "formSet"
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择审核人"
    },
    model: {
      value: (_vm.formUser.userid),
      callback: function($$v) {
        _vm.$set(_vm.formUser, "userid", $$v)
      },
      expression: "formUser.userid"
    }
  }, _vm._l((_vm.users), function(item) {
    return _c('el-option', {
      key: item.userId,
      attrs: {
        "label": item.name,
        "value": item.userId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "请选择审核方式"
    },
    model: {
      value: (_vm.formUser.reviewWayid),
      callback: function($$v) {
        _vm.$set(_vm.formUser, "reviewWayid", $$v)
      },
      expression: "formUser.reviewWayid"
    }
  }, _vm._l((_vm.reviewWays), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formUpdateVisible),
      expression: "formUpdateVisible"
    }],
    attrs: {
      "inline": true,
      "model": _vm.filtersForm,
      "size": "mini"
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "设备编码"
    },
    model: {
      value: (_vm.filtersForm.mnCode),
      callback: function($$v) {
        _vm.$set(_vm.filtersForm, "mnCode", $$v)
      },
      expression: "filtersForm.mnCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "请选择项目",
      "filterable": ""
    },
    model: {
      value: (_vm.filtersForm.ProjectId),
      callback: function($$v) {
        _vm.$set(_vm.filtersForm, "ProjectId", $$v)
      },
      expression: "filtersForm.ProjectId"
    }
  }, _vm._l((_vm.projects), function(item) {
    return _c('el-option', {
      key: item.projectId,
      attrs: {
        "label": item.name,
        "value": item.projectId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getDeviceForm()
      }
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.formUpdateVisible),
      expression: "formUpdateVisible"
    }],
    ref: "devicesForm",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.devicesForm,
      "highlight-current-row": "",
      "border": "",
      "height": "300px",
      "size": "mini"
    },
    on: {
      "selection-change": _vm.selsFormChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mnCode",
      "label": "设备编码",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "projectName",
      "label": "项目",
      "sortable": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formUpdateVisible),
      expression: "formUpdateVisible"
    }],
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSizeForm,
      "total": _vm.totalForm,
      "page-sizes": [20, 50, 100, 200],
      "current-page": _vm.pageForm
    },
    on: {
      "current-change": _vm.handleFormCurrentChange,
      "size-change": _vm.handleFormSizeChange,
      "update:currentPage": function($event) {
        _vm.pageForm = $event
      },
      "update:current-page": function($event) {
        _vm.pageForm = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancleSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitData.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-058f9cd8"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/review/ReviewSet.vue
// module id = 1870
// module chunks = 1